import { render } from "./CustomFilters.vue?vue&type=template&id=06eceda1&scoped=true"
import script from "./CustomFilters.vue?vue&type=script&lang=js"
export * from "./CustomFilters.vue?vue&type=script&lang=js"

import "./CustomFilters.vue?vue&type=style&index=0&id=06eceda1&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eceda1"]])

export default __exports__